import React, { useState, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { clearYourTownloopSearchValue } from '@/store/slices/searchBarSlice';
import { eventBus } from '@/utils/eventBus';
import styles from './Addresses.module.scss';
import icon1 from '@/assets/images/路径 5.png';
import { Table, Button, Modal, Form, Input, App, Checkbox, Select } from 'antd';
import {
  getUserAddressList,
  saveOrderAddress,
  deleteOrderAddress
} from '@/api/order';
import { useTranslation } from 'react-i18next';

interface IForm {
  id: string;
  first_name: string;//名字
  last_name: string;//姓氏
  recipient_phone: string;//电话
  email: string;//邮箱
  extension: string;//分机号
  address: string;//地址
  building: string;//楼栋
  zip_code: string;//邮编
  city: string;//城市
  state: string;//州
  is_default: boolean;
};
const { Option } = Select;

const Addresses: React.FC = () => {

  const { message } = App.useApp();
    //国际化语言切换
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();

  //是否是手机端
  const isMobile = useAppSelector((state) => state.searchBar.isMobile);

  //yourTownloopSearchValue关键字
  const yourTownloopSearchValue = useAppSelector((state) => state.searchBar.yourTownloopSearchValue);

  //美国州列表
  const StateList = useAppSelector((state) => state.common.StateList);

  //useState和Ant Design 的 Form 组件关联起来需要用到Form.useForm()
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);

  //是新增还是编辑
  const [isEdit, setIsEdit] = useState(false);


  //打开地址新增
  const showModal = () => {
    setIsEdit(false);
    //给表单回传默认值
    form.setFieldsValue({
      id: '',
      first_name: '',
      last_name: '',
      recipient_phone: '',
      email: '',
      extension: '',
      address: '',
      building: '',
      zip_code: '',
      city: '',
      state: '',
      is_default: false,
    });
    setIsModalOpen(true);
  };

  //打开地址编辑
  const showModalEdit = (record: IForm) => {
    setIsEdit(true);
    console.log(record, 'record');

    //给表单回传默认值
    form.setFieldsValue({
      id: record.id,
      first_name: record.first_name,
      last_name: record.last_name,
      recipient_phone: record.recipient_phone,
      email: record.email,
      extension: record.extension,
      address: record.address,
      building: record.building,
      zip_code: record.zip_code,
      city: record.city,
      state: record.state,
      is_default: record.is_default,
    });
    setIsModalOpen(true);
  }


  //删除地址
  const delAddress = (record: IForm, index: number) => {

    console.log(record, 'record');

    Modal.confirm({
      title: 'Are you sure you want to delete this address?',
      content: 'This action cannot be undone.',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {

        deleteOrderAddress({
          id: record.id,
        }).then((res) => {
          if (res.code == 200) {
            message.success('删除成功');
            getUserAddressListData();
          }
        });


      },
    });

  }

  // 获取用户收货地址列表
  const getUserAddressListData = () => {
    getUserAddressList().then((res) => {
      console.log(res, 'getUserAddressListData res');
      if (res.code == 200) {
        setDataSource(res.data);
      }
    });
  }

  //提交表单
  const handleOk = () => {
    form
      .validateFields()
      .then(values => {
        console.log('values', values);

       

        saveOrderAddress({
          ...values,
        }).then((res) => {
          if (res.code == 200) {
            message.success(t('Addresses.Success'));
            getUserAddressListData();
          } else {
            message.error(res.msg);
          }
        });

        setIsModalOpen(false);
      }, () => {
      });
  };

  //取消表单
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // 地址列表数据
  const [dataSource, setDataSource] = useState<any[]>([


  ]);


  //设置默认地址
  const handleAddAddress = (index: number) => {

    saveOrderAddress({
      ...dataSource[index],
      is_default: true,
    }).then((res) => {
      if (res.code == 200) {
        message.success(t('Addresses.Success'));
        getUserAddressListData();
      } else {
        message.error(res.msg);
      }
    });
  }

  //表格列配置
  const columns = [
    {
      title: t('Addresses.Consignee'),
      dataIndex: 'first_name',
      key: 'first_name',
      align: 'left' as const,
      render: (_: any, record: any, index: number) => <span className={styles['cell-main']}>{
        record.first_name + record.last_name
      }</span>,
    },
    {
      title: t('Addresses.Phone'),
      dataIndex: 'recipient_phone',
      key: 'recipient_phone',
      align: 'left' as const,
      render: (text: string) => <span className={styles['cell-main']}>{text}</span>,
    },
    {
      title: t('Addresses.Email'),
      dataIndex: 'email',
      key: 'email',
      align: 'left' as const,
      render: (text: string) => <span className={styles['cell-main']}>{text}</span>,
    },
    {
      title: t('Addresses.Address'),
      dataIndex: 'address',
      key: 'address',
      align: 'left' as const,
      render: (_: any, record: any, index: number) => <span className={styles['cell-main']}>{
        record.building + ' ' + record.address + ', ' + record.city + ', ' + record.state + ' ' + record.zip_code
      }</span>,
    },
    {
      title: t('Addresses.Operation'),
      key: 'operation',
      align: 'left' as const,
      minWidth: 120,
      render: (_: any, record: any, index: number) => (
        <div className={styles['cell-ops']}>
          <div className={styles['cell-link']} onClick={() => showModalEdit(record)}>(t('Addresses.Modify'))</div>
          <div className={styles['cell-link']} onClick={() => delAddress(record, index)}>(t('Addresses.Delete'))</div>
          {/* <div className={styles['cell-link']}>Remove From Top</div> */}
        </div>
      ),
    },
    {
      title: t('Addresses.DefaultSettings'),
      key: '',
      minWidth: 140,
      align: 'left' as const,
      render: (_: any, record: any, index: number) => (
        record.is_default ? (
          <div className={styles['cell-default']}>(t('Addresses.DefaultAddress'))</div>
        ) : (
          <div
            className={styles['cell-set-default']}
            onClick={() => handleAddAddress(index)}
          >(t('Addresses.SetAsDefault'))</div>
        )
      ),
    },
  ];
  
  
  //mounted 和unmounted
  useEffect(() => {
    return () => {
      console.log('组件销毁时');
      //销毁清除townloopSearchValue的值
      eventBus.emit('deleteTownloopSearchValue');
      dispatch(clearYourTownloopSearchValue());
      getUserAddressListData();
    }
  }, []);

  //yourTownloopSearchValue关键字的监听
  useEffect(() => {
    console.log('Addresses组件yourTownloopSearchValue', yourTownloopSearchValue);
    
  }, [yourTownloopSearchValue])

  return (
    <div className={styles['addresses-box']}>
      <div className={styles['addresses-header']}>
        <span className={styles['addresses-title']}>{t("Addresses.MyAddresses")}</span>
        <Button
          className={styles['addresses-add-btn']}
          onClick={showModal}
        >{t("Addresses.AddAddress")}</Button> 
      </div>
      {isMobile ? (
        <div className={styles['addresses-mobile-list']}>
          {dataSource.map((item, idx) => (
            <div className={styles['address-card']} key={item.id}>
              <div>
                <b>(t('Addresses.Consignee'))</b> {item.first_name + item.last_name}
              </div>
              <div>
                <b>(t('Addresses.Phone'))</b> {item.recipient_phone}
              </div>
              <div>
                <b>(t('Addresses.Email'))</b> {item.email}
              </div>
              <div>
                <b>(t('Addresses.Address'))</b> {item.building + ' ' + item.address + ', ' + item.city + ', ' + item.state + ' ' + item.zip_code}
              </div>
              <div className={styles['address-card-ops']}>
                <span className={styles['cell-link']} onClick={() => showModalEdit(item)}>(t('Addresses.Modify'))</span>
                <span className={styles['cell-link']} onClick={() => delAddress(item, idx)}>(t('Addresses.Delete'))</span>
                {item.is_default ? (
                  <span className={styles['cell-default']}>(t('Addresses.DefaultAddress'))</span>
                ) : (
                  <span className={styles['cell-set-default']} onClick={() => handleAddAddress(idx)}>(t('Addresses.SetAsDefault'))</span>
                )}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <Table
          className={styles['addresses-table']}
          dataSource={dataSource}
          columns={columns}
          rowKey="id"
          pagination={false}
          bordered={false}
        />
      )}

      {/* 修改收货地址 */}
      <Modal
        title={t('Addresses.ShippingAddress')}
        closable={{ 'aria-label': 'Custom Close Button' }}
        width={isMobile ? '90%' : '60%'}
        maskClosable={false}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText={t('Addresses.OkText')}
        cancelText={t('Addresses.cancelText')}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            label="id"
            name="id"
            style={{ display: 'none' }}
          >
            <Input disabled />
          </Form.Item>

          <div className={styles['form-row']}>
            <div className={styles['form-col']}>
              <Form.Item
                label={t('login.firstName')}
                name="first_name"
                rules={[{ required: true, message: t('storeEntry.Pleaseenterfirstname') }]}
              >
                <Input />
              </Form.Item>
            </div>
            <div className={styles['form-col']}>
              <Form.Item
                label={t('login.lastName')}
                name="last_name"
                rules={[{ required: true, message: t('storeEntry.Pleaseenterlastname') }]}
              >
                <Input />
              </Form.Item>
            </div>
          </div>

          <div className={styles['form-row']}>
            <div className={styles['form-col']}>
              <Form.Item
                label={t('membershipChild.Phone')}
                name="recipient_phone"
                rules={[{ required: true, message: t('login.phonePl') }]}
              >
                <Input />
              </Form.Item>
            </div>
            <div className={styles['form-col']}>
              <Form.Item
                label={t('membershipChild.Email')}
                name="email"
                rules={[{ required: true, message: t('login.EmailAddressPl') }]}
              >
                <Input />
              </Form.Item>
            </div>
          </div>

          <div className={styles['form-row']}>
            <div className={styles['form-col']}>
              <Form.Item
                label={t('Addresses.Extension')}
                name="extension"
              >
                <Input />
              </Form.Item>
            </div>
            <div className={styles['form-col']}>
              <Form.Item
                label={t('membershipChild.Address')}
                name="address"
                rules={[{ required: true, message: t('PlaceOrderChild.Pleaseinputaddress') }]}
              >
                <Input />
              </Form.Item>
            </div>
          </div>

          <div className={styles['form-row']}>
            <div className={styles['form-col']}>
              <Form.Item
                label={t('membershipChild.AptBuilding')}
                name="building"
              >
                <Input />
              </Form.Item>
            </div>
            <div className={styles['form-col']}>
              <Form.Item
                label={t('membershipChild.ZipCode')}
                name="zip_code"
                rules={[{ required: true, message: t('PlaceOrderChild.PleaseinputZipcode') }]}
              >
                <Input />
              </Form.Item>
            </div>
          </div>

          <div className={styles['form-row']}>
            <div className={styles['form-col']}>
              <Form.Item
                label={t('storeEntry.CityOrTownship')}
                name="city"
                rules={[{ required: true, message: t('PlaceOrderChild.PleaseinputCity') }]}
              >
                <Input />
              </Form.Item>
            </div>
            <div className={styles['form-col']}>
              <Form.Item
                label={t('storeEntry.State')}
                name="state"
                rules={[{ required: true, message: t('PlaceOrderChild.PleaseinputState') }]}
              >
                <Select>
                  {
                    StateList.map((item, index) => (
                      <Option value={item.value} key={index}>{item.label}</Option>
                    ))
                  }

                </Select>
              </Form.Item>
            </div>
          </div>

          <Form.Item
            label={t('Addresses.IsDefault')}
            name="is_default"
            valuePropName="checked"
          >
            <Checkbox></Checkbox>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Addresses; 